module.exports = __webpack_public_path__ + "media/v2/components/Blog/shared/img/winner_img-10d7cebf9f04060c859974bc6df21c01.png";